// @flow
import * as React from 'react';
import capitalize from 'capitalize';
import style from './style';

interface Props {
 givenName: string,
 familyName: string,
 image: string,
 tagLine: string,
}

const UserModalHeader = (context: Props): React.Element<any> => (
  <div style={style.content}>
    <img
      style={style.picture}
      alt={context.givenName}
      src={`${context.image.split('?')[0]}?sz=100`}
    />
    <div style={style.info}>
      <h2>{capitalize.words(`${context.givenName} ${context.familyName}`)}</h2>
      <small style={style.subInfo}>{context.tagLine}</small>
    </div>
  </div>
);

export default UserModalHeader;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/UserModalHeader/UserModalHeader.js